import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge"]
  static values = { url: String, nextStatus: String }

  connect() {
    // Nothing to do - click handled via data-action
  }

  async toggleStatus(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    
    const badge = this.badgeTarget
    if (!badge) return
    
    // Store the current status before toggling
    const currentStatus = badge.querySelector(".status-text")?.textContent?.trim()
    
    // Add pulse animation to badge
    badge.classList.add("status-pulse-animation")
    badge.style.pointerEvents = "none"
    badge.style.opacity = "0.7"
    
    const nextStatus = this.nextStatusValue
    const url = this.urlValue
    
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          appointment_status: { next_status: nextStatus }
        })
      })
      
      if (response.ok) {
        const data = await response.json()
        // Toggle the nextStatusValue for next click
        this.nextStatusValue = nextStatus === "paid" ? "pay_at_inspection" : "paid"
        
        // Update badge text after a brief delay for visual feedback
        setTimeout(() => {
          const textEl = badge.querySelector(".status-text")
          if (textEl) {
            textEl.textContent = data.label
          }
          // Update classes for new status
          const newClasses = this.statusClasses(nextStatus)
          const baseClass = "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full cursor-pointer hover:opacity-80 transition"
          badge.className = `${baseClass} ${newClasses}`
        }, 300)
      } else {
        console.error("Status toggle failed with status:", response.status)
        const textEl = badge.querySelector(".status-text")
        if (textEl) {
          textEl.textContent = "Error"
        }
        setTimeout(() => {
          if (textEl) {
            textEl.textContent = currentStatus || "Unknown"
          }
        }, 2000)
      }
    } catch (error) {
      console.error("Status toggle failed:", error)
    } finally {
      // Re-enable after animation completes
      setTimeout(() => {
        badge.classList.remove("status-pulse-animation")
        badge.style.pointerEvents = ""
        badge.style.opacity = ""
      }, 600)
    }
  }

  statusClasses(status) {
    const classes = {
      "paid": "bg-green-100 text-green-800",
      "pay_at_inspection": "bg-amber-100 text-amber-800",
      "draft": "bg-yellow-100 text-yellow-800"
    }
    return classes[status] || "bg-slate-100 text-slate-800"
  }
}
